import { Injectable } from "@angular/core";
import { ApiGateway } from "../../../api-gateway";
import { HttpClient, HttpHeaders, HttpResponse } from "@angular/common/http";
import { Environment } from "app/decorators/environment.decorator";

@Injectable()
export class MetaService {
    @Environment("baseUrl") baseUrl: string;

    constructor(public gw: ApiGateway, private http: HttpClient) {}

    checkDefaulters() {
        let user = JSON.parse(localStorage.getItem("user"));
        if (!user?.id) {
            return;
        }
        return new Promise<any>((resolve, reject) => {
            this.gw.get(`order/check-defaulters/${user?.id}`).subscribe({
                next: (res: HttpResponse<any>) => {
                    resolve(res);
                },
                error: (err) => {
                    reject(err);
                },
            });
        });
    }

    confirmdefaulters() {
        return new Promise<any>((resolve, reject) => {
            this.gw.post(`order/confirm-defaulters/`).subscribe({
                next: (res: HttpResponse<any>) => {
                    resolve(res);
                },
                error: (err) => {
                    reject(err);
                },
            });
        });
    }

    confirmDefaultersWithToken(authToken) {
        return new Promise((resolve, reject) => {
            const endpoint = this.baseUrl + "user/confirm-defaulters";
            let headers = new HttpHeaders();
            headers = headers.append("X-Auth-Token", authToken);

            this.http.post(endpoint, null, { headers: headers }).subscribe({
                next: (res) => {
                    resolve(res);
                },
                error: (err) => {
                    reject(err);
                },
            });
        });
    }

    getMessageToken(authToken): Promise<any> {
        return new Promise((resolve, reject) => {
            const endpoint = this.baseUrl + "clinicall-defaulter/";
            let headers = new HttpHeaders();
            headers = headers.append("X-Auth-Token", authToken);

            this.http.get(endpoint, { headers: headers }).subscribe({
                next: (res) => {
                    resolve(res);
                },
                error: (err) => {
                    reject(err);
                },
            });
        });
    }

    getMessage():Promise<any>{
        return new Promise((resolve, reject) => {
             const endpoint = "clinicall-defaulter/";
            this.gw.get(endpoint).subscribe({
                next: (res) => {
                    resolve(res);
                },
                error: (err) => {
                    reject(err);
                },
            });
        });
    }

    getMessageBlockedToken(authToken?):Promise<any> {
        return new Promise((resolve, reject) => {
            const endpoint = this.baseUrl + "clinicall-defaulter/blocked";
            let headers = new HttpHeaders();
            headers = headers.append("X-Auth-Token", authToken);

            this.http.get(endpoint, { headers: headers }).subscribe({
                next: (res) => {
                    resolve(res);
                },
                error: (err) => {
                    reject(err);
                },
            });
        });
    }

    getMessageBlocked():Promise<any> {
        return new Promise((resolve, reject) => {
            const endpoint =  "clinicall-defaulter/blocked";

            this.gw.get(endpoint).subscribe({
                next: (res) => {
                    resolve(res);
                },
                error: (err) => {
                    reject(err);
                },
            });
        });
    }
}
